
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Smartphone, Clock, MapPin, Calendar, Users, BarChart3, Camera, Palmtree } from 'lucide-react';

function FeaturesSection() {
  return (
    <Container className="py-5" style={{ marginTop: '60px', marginBottom: '20px' }}>
      <div className="text-center" style={{ marginBottom: '48px' }}>
        <h2 style={{
          fontSize: '2.2rem',
          fontWeight: '700',
          color: '#1f2937',
          marginBottom: '16px',
          marginTop: '48px',
        }}>
          Kluczowe funkcjonalności
        </h2>
      </div>

      <Row className="g-3 justify-content-center">
        {[
          { icon: Smartphone, label: 'Aplikacja mobilna' },
          { icon: Clock, label: 'Rejestracja czasu' },
          { icon: MapPin, label: 'Lokalizacja GPS' },
          { icon: Calendar, label: 'Grafik i zmiany' },
          { icon: Users, label: 'Lista obecności' },
          { icon: BarChart3, label: 'Automatyczne raporty' },
          { icon: Camera, label: 'Notatka ze zdjęciem' },
          { icon: Palmtree, label: 'Wnioski urlopowe' },
        ].map((feature, idx) => {
          const IconComponent = feature.icon;
          return (
            <Col key={idx} xs={6} sm={4} md={3} lg={3}>
              <div style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                padding: '20px 16px',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                border: '1px solid #e5e7eb',
                minHeight: '120px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f8f9fa';
                e.currentTarget.style.boxShadow = 'none';
              }}>
                <IconComponent size={22} style={{ color: '#407EF9', marginBottom: '8px' }} />
                <div style={{ fontSize: '0.875rem', color: '#4b5563', fontWeight: '500' }}>
                  {feature.label}
                </div>
              </div>
            </Col>
          );
        })}
      </Row>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Button
          href="/funkcje"
          variant="link"
          style={{
            color: '#6b7280',
            fontSize: '1rem',
            fontWeight: '500',
            textDecoration: 'none',
            padding: '0',
            transition: 'all 0.3s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#407EF9';
            e.currentTarget.style.gap = '12px';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#6b7280';
            e.currentTarget.style.gap = '8px';
          }}
        >
          Zobacz wszystkie funkcje →
        </Button>
      </div>
    </Container>
  );
}

export default FeaturesSection;
